import * as THREE from 'three'
import stone from '../../static/textures/block/stone.png'
import coal_ore from '../../static/textures/block/coal_ore.png'
import iron_ore from '../../static/textures/block/iron_ore.png'
import grass_side from '../../static/textures/block/grass_block_side.png'
import grass_top_green from '../../static/textures/block/grass_top_green.png'
import dirt from '../../static/textures/block/dirt.png'
import oak_log from '../../static/textures/block/oak_log.png'
import oak_log_top from '../../static/textures/block/oak_log_top.png'
import oak_leaves from '../../static/textures/block/oak_leaves.png'
import sand from '../../static/textures/block/sand.png'
import water from '../../default-textures-master/textures/blocks/water_placeholder.png'
import oak_wood from '../../static/textures/block/oak_planks.png'
import diamond from '../../static/textures/block/diamond_block.png'
import quartz from '../../static/textures/block/quartz_block_side.png'
import glass from '../../static/textures/block/glass.png'
import bedrock from '../../static/textures/block/bedrock.png'
import crafting_table_top from '../../static/textures/block/crafting_table_top.png'
import crafting_table_side from '../../static/textures/block/crafting_table_side.png'
import crafting_table_front from '../../static/textures/block/crafting_table_front.png'
import lava from '../../default-textures-master/textures/blocks/lava_still.png'
import obsidian from '../../static/textures/block/obsidian.png'
import cobblestone from '../../static/textures/block/cobblestone.png'
import tnt_side from '../../static/textures/block/tnt_side.png'
import tnt_top from '../../static/textures/block/tnt_top.png'
import tnt_bottom from '../../static/textures/block/tnt_bottom.png'
import netherrack from '../../static/textures/block/netherrack.png'
import soul_sand from '../../static/textures/block/soul_sand.png'
import glowstone from '../../static/textures/block/glowstone.png'
import nether_quartz_ore from '../../static/textures/block/nether_quartz_ore.png'

export enum MaterialType {
  grass = 'grass',
  dirt = 'dirt',
  tree = 'tree',
  leaf = 'leaf',
  sand = 'sand',
  stone = 'stone',
  coal = 'coal',
  wood = 'wood',
  diamond = 'diamond',
  quartz = 'quartz',
  glass = 'glass',
  bedrock = 'bedrock',
  craftingTable = 'craftingTable',
  water = 'water',
  lava = 'lava',
  obsidian = 'obsidian',
  cobblestone = 'cobblestone',
  tnt = 'tnt',
  whitespaceGrass = 'whitespaceGrass',
  whitespaceDirt = 'whitespaceDirt',
  whitespaceLog = 'whitespaceLog',
  whitespaceLeaf = 'whitespaceLeaf',
  netherrack = 'netherrack',
  soulSand = 'soulSand',
  glowstone = 'glowstone',
  netherQuartz = 'netherQuartz',
  netherPortal = 'netherPortal'
}
let loader = new THREE.TextureLoader()

// load texture
const grassTopMaterial = loader.load(grass_top_green)
const grassMaterial = loader.load(grass_side)
const treeMaterial = loader.load(oak_log)
const treeTopMaterial = loader.load(oak_log_top)
const dirtMaterial = loader.load(dirt)
const stoneMaterial = loader.load(stone)
const coalMaterial = loader.load(coal_ore)
const ironMaterial = loader.load(iron_ore)
const leafMaterial = loader.load(oak_leaves)
const sandMaterial = loader.load(sand)
const waterMaterial = loader.load(water)
const woodMaterial = loader.load(oak_wood)
const diamondMaterial = loader.load(diamond)
const quartzMaterial = loader.load(quartz)
const glassMaterial = loader.load(glass)
const bedrockMaterial = loader.load(bedrock)
const craftingTableTopMaterial = loader.load(crafting_table_top)
const craftingTableSideMaterial = loader.load(crafting_table_side)
const craftingTableFrontMaterial = loader.load(crafting_table_front)
const lavaMaterial = loader.load(lava)
const obsidianMaterial = loader.load(obsidian)
const cobblestoneMaterial = loader.load(cobblestone)
const tntSideMaterial = loader.load(tnt_side)
const tntTopMaterial = loader.load(tnt_top)
const tntBottomMaterial = loader.load(tnt_bottom)
const netherrackMaterial = loader.load(netherrack)
const soulSandMaterial = loader.load(soul_sand)
const glowstoneMaterial = loader.load(glowstone)
const netherQuartzMaterial = loader.load(nether_quartz_ore)

// pixelate texture
const colorTextures = [
  grassTopMaterial,
  grassMaterial,
  treeMaterial,
  treeTopMaterial,
  dirtMaterial,
  stoneMaterial,
  coalMaterial,
  ironMaterial,
  leafMaterial,
  sandMaterial,
  waterMaterial,
  woodMaterial,
  diamondMaterial,
  quartzMaterial,
  glassMaterial,
  bedrockMaterial,
  craftingTableTopMaterial,
  craftingTableSideMaterial,
  craftingTableFrontMaterial,
  lavaMaterial,
  obsidianMaterial,
  cobblestoneMaterial,
  tntSideMaterial,
  tntTopMaterial,
  tntBottomMaterial,
  netherrackMaterial,
  soulSandMaterial,
  glowstoneMaterial,
  netherQuartzMaterial
]

for (const texture of colorTextures) {
  texture.magFilter = THREE.NearestFilter
  texture.minFilter = THREE.NearestFilter
  texture.encoding = THREE.sRGBEncoding
}

// lava_still.png is a 20-frame vertical animation strip (16x320) — crop the
// UVs to a single 16x16 frame and step through frames at runtime.
const LAVA_FRAMES = 20
lavaMaterial.repeat.set(1, 1 / LAVA_FRAMES)
lavaMaterial.offset.set(0, 0)

export default class Materials {
  materials = {
    grass: [
      new THREE.MeshStandardMaterial({ map: grassMaterial }),
      new THREE.MeshStandardMaterial({ map: grassMaterial }),
      new THREE.MeshStandardMaterial({
        map: grassTopMaterial
      }),
      new THREE.MeshStandardMaterial({ map: dirtMaterial }),
      new THREE.MeshStandardMaterial({ map: grassMaterial }),
      new THREE.MeshStandardMaterial({ map: grassMaterial })
    ],
    dirt: new THREE.MeshStandardMaterial({ map: dirtMaterial }),
    sand: new THREE.MeshStandardMaterial({ map: sandMaterial }),
    tree: [
      new THREE.MeshStandardMaterial({ map: treeMaterial }),
      new THREE.MeshStandardMaterial({ map: treeMaterial }),
      new THREE.MeshStandardMaterial({ map: treeTopMaterial }),
      new THREE.MeshStandardMaterial({ map: treeTopMaterial }),
      new THREE.MeshStandardMaterial({ map: treeMaterial }),
      new THREE.MeshStandardMaterial({ map: treeMaterial })
    ],
    leaf: new THREE.MeshStandardMaterial({
      map: leafMaterial,
      color: new THREE.Color(0, 1, 0),
      transparent: true
    }),
    water: new THREE.MeshStandardMaterial({
      map: waterMaterial,
      color: new THREE.Color(0x2f8fff),
      emissive: new THREE.Color(0x0a3158),
      emissiveIntensity: 0.2,
      transparent: true,
      opacity: 0.88,
      depthWrite: true,
      side: THREE.DoubleSide
    }),
    stone: new THREE.MeshStandardMaterial({ map: stoneMaterial }),
    coal: new THREE.MeshStandardMaterial({ map: coalMaterial }),
    wood: new THREE.MeshStandardMaterial({ map: woodMaterial }),
    diamond: new THREE.MeshStandardMaterial({ map: diamondMaterial }),
    quartz: new THREE.MeshStandardMaterial({ map: quartzMaterial }),
    glass: new THREE.MeshStandardMaterial({
      map: glassMaterial,
      transparent: true
    }),
    bedrock: new THREE.MeshStandardMaterial({ map: bedrockMaterial }),
    // lava glows on its own and ignores scene lighting almost entirely
    lava: new THREE.MeshStandardMaterial({
      map: lavaMaterial,
      color: new THREE.Color(0xffb83d),
      emissive: new THREE.Color(0xff5a00),
      emissiveMap: lavaMaterial,
      emissiveIntensity: 1.4
    }),
    obsidian: new THREE.MeshStandardMaterial({ map: obsidianMaterial }),
    cobblestone: new THREE.MeshStandardMaterial({ map: cobblestoneMaterial }),
    tnt: [
      new THREE.MeshStandardMaterial({ map: tntSideMaterial }),
      new THREE.MeshStandardMaterial({ map: tntSideMaterial }),
      new THREE.MeshStandardMaterial({ map: tntTopMaterial }),
      new THREE.MeshStandardMaterial({ map: tntBottomMaterial }),
      new THREE.MeshStandardMaterial({ map: tntSideMaterial }),
      new THREE.MeshStandardMaterial({ map: tntSideMaterial })
    ],
    craftingTable: [
      new THREE.MeshStandardMaterial({ map: craftingTableSideMaterial }),
      new THREE.MeshStandardMaterial({ map: craftingTableSideMaterial }),
      new THREE.MeshStandardMaterial({ map: craftingTableTopMaterial }),
      new THREE.MeshStandardMaterial({ map: woodMaterial }),
      new THREE.MeshStandardMaterial({ map: craftingTableFrontMaterial }),
      new THREE.MeshStandardMaterial({ map: craftingTableSideMaterial })
    ],
    whitespaceGrass: [
      new THREE.MeshStandardMaterial({ map: grassMaterial, color: new THREE.Color(0xffffff), roughness: 0.9 }),
      new THREE.MeshStandardMaterial({ map: grassMaterial, color: new THREE.Color(0xffffff), roughness: 0.9 }),
      new THREE.MeshStandardMaterial({ map: grassTopMaterial, color: new THREE.Color(0xffffff), roughness: 0.9 }),
      new THREE.MeshStandardMaterial({ map: dirtMaterial, color: new THREE.Color(0x222222), roughness: 0.9 }),
      new THREE.MeshStandardMaterial({ map: grassMaterial, color: new THREE.Color(0xffffff), roughness: 0.9 }),
      new THREE.MeshStandardMaterial({ map: grassMaterial, color: new THREE.Color(0xffffff), roughness: 0.9 })
    ],
    whitespaceDirt: new THREE.MeshStandardMaterial({ map: dirtMaterial, color: new THREE.Color(0x222222), roughness: 0.9 }),
    whitespaceLog: [
      new THREE.MeshStandardMaterial({ map: quartzMaterial, color: new THREE.Color(0xffffff), roughness: 0.9 }),
      new THREE.MeshStandardMaterial({ map: quartzMaterial, color: new THREE.Color(0xffffff), roughness: 0.9 }),
      new THREE.MeshStandardMaterial({ map: treeTopMaterial, color: new THREE.Color(0xdddddd), roughness: 0.9 }),
      new THREE.MeshStandardMaterial({ map: treeTopMaterial, color: new THREE.Color(0xdddddd), roughness: 0.9 }),
      new THREE.MeshStandardMaterial({ map: quartzMaterial, color: new THREE.Color(0xffffff), roughness: 0.9 }),
      new THREE.MeshStandardMaterial({ map: quartzMaterial, color: new THREE.Color(0xffffff), roughness: 0.9 })
    ],
    whitespaceLeaf: new THREE.MeshStandardMaterial({
      map: leafMaterial,
      color: new THREE.Color(0xffffff),
      transparent: true,
      roughness: 0.9
    }),
    netherrack: new THREE.MeshStandardMaterial({ map: netherrackMaterial }),
    soulSand: new THREE.MeshStandardMaterial({ map: soulSandMaterial }),
    glowstone: new THREE.MeshStandardMaterial({
      map: glowstoneMaterial,
      emissive: new THREE.Color(0xffaa44),
      emissiveMap: glowstoneMaterial,
      emissiveIntensity: 1.2
    }),
    netherQuartz: new THREE.MeshStandardMaterial({ map: netherQuartzMaterial }),
    netherPortal: new THREE.MeshStandardMaterial({
      color: new THREE.Color(0x9a22f8),
      emissive: new THREE.Color(0x500a88),
      emissiveIntensity: 1.5,
      transparent: true,
      opacity: 0.75,
      depthWrite: true,
      side: THREE.DoubleSide
    })
  }

  get = (
    type: MaterialType
  ): THREE.MeshStandardMaterial | THREE.MeshStandardMaterial[] => {
    return this.materials[type]
  }

  lavaFrame = 0
  lavaFrameTimer = 0

  // advance animated textures; called once per frame from Terrain.update
  tickAnimations = (nowMs: number) => {
    if (nowMs - this.lavaFrameTimer < 140) return
    this.lavaFrameTimer = nowMs
    this.lavaFrame = (this.lavaFrame + 1) % LAVA_FRAMES
    lavaMaterial.offset.y = this.lavaFrame / LAVA_FRAMES
  }
}
